const LOGIN_TYPE = Object.freeze({
  django: 0, ldap: 1, ad: 2, sso: 3, saml: 4,
})

const ACCESS_TOKEN = 'AccessToken'
const IMPERSONATE_KEY = 'impersonate'
const TOKEN_KEY = 'token'

export default {
  ACCESS_TOKEN,
  IMPERSONATE_KEY,
  LOGIN_TYPE,
  TOKEN_KEY,
}
